<template>
  <div class="loading-wrapper" v-if="isLoading">
    <div style="display: flex;justify-content: center;">
      <div class="loading-border"></div>
      <div class="loading-logo-wrapper">
        <img
          class="loading-logo"
          src="https://cdn.parcelex.com.br/assets/v3/icons/ame-symbol.svg"
          alt="Loading"
          title="Loading"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loader',
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style style="scss" scoped>
  .loading-wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .loading-border {
    align-self: center;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: conic-gradient(transparent 25%, #ED0059);
    animation: splash-loading-spinner 1s linear infinite;
    position: absolute;
  }

  .loading-logo-wrapper {
    position: relative;
    outline: 4px solid white;
    background: white;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    border-radius: 50%;
    width: 48px;
    height: 48px;
  }

  .loading-logo {
    width: 36px;
    height: 36px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>
